<template>
  <div class="no-cards">
    <img src="/assets/images/platne_kartice.svg" alt=""/>
    <h2 class="title">{{ $t('paymentCards.noCard.title') }}</h2>
    <p class="description">
      {{ $t('paymentCards.noCard.description') }}
      <br>
      {{ $t('paymentCards.addCardsNote') }}
    </p>
    <base-button variant="primary" @click="emitClickEvent">{{ $t('paymentCards.noCard.addCard') }}</base-button>
  </div>
</template>

<script>
export default {
  name: 'no-payment-cards',
  methods: {
    emitClickEvent () {
      this.$emit('add-card')
    }
  }
}
</script>

<style scoped lang="scss">
.no-cards {
  padding: 5.3rem;
  text-align: center;
  color: $text;
  background-color: $white;
  border-radius: 5px;

  img {
    display: block;
    width: 100%;
    max-width: 280px;
    height: auto;
    margin: 0 auto 2.4rem;
  }

  .title {
    font-size: 3.2rem;
    font-weight: normal;
    margin-bottom: 1.6rem;
  }

  .description {
    font-size: 1.6rem;
    color: $text-alt;
    margin-bottom: 4rem;
  }
}
</style>
